<template>
  <div class="animated fadeIn">
    <b-card-group column>
      <b-card header="% General De Cumplimiento">
        <div>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th scope="row">Cumple</th>

                <td>{{graficaGeneral['Cumple']  }} &#37;</td>
              </tr>
              <tr>
                <th scope="row">Necesita Mejorar</th>

                <td>{{graficaGeneral['Necesita Mejorar']  }} &#37;</td>
              </tr>
              <tr>
                <th scope="row">No Cumple</th>

                <td>{{graficaGeneral['No Cumple'] }} &#37;</td>
              </tr>
              <!-- <tr>
                <th scope="row">No Aplica</th>
                <td>{{graficaGeneral[9]}}</td>
                <td></td>
              </tr> -->
              <tr>
                <th scope="row">% de Cumplimiento</th>
                <td colspan="2">{{graficaGeneral['Cumple']}} &#37;</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <b-card header="Estado De cumplimiento">
          <graficas-cumplimiento />
      </b-card>
    </b-card-group>
    <b-card-group derk>
      <b-card header="Cumplimiento Por Items">
        <div >
           <table class="table table-bordered">
            <tbody>
               <tr v-for="(graf,index) in graficaTipoSeg" :key="index">
                <th scope="row" >{{graf.key}}</th>
                <td>{{graf.value}} &#37;</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <b-card header="Porcentaje De Cumplimiento Por Items">
        <div class="chart-wrapper">
          <cumplimiento-item/>
        </div>
      </b-card>
    </b-card-group>
  </div>
</template>
<script>
import {mapActions,mapMutations,mapState  } from "vuex";
import graficasCumplimiento from './graficasCumplimiento'
import cumplimientoItem from './cumplimientoItem'
export default {
  name: 'resultadoRiesgoQuimico',
  components: {
    graficasCumplimiento,
    cumplimientoItem
  },
   methods: {
        ...mapMutations('listaChequeo', [
          'resetGraphics'
        ]),
        ...mapActions('listaChequeo',[
            'verGraficas'
        ])
    },
    beforeDestroy() {
      this.resetGraphics();
    },
    computed: {
         ...mapState('listaChequeo',[
            'graficaGeneral',
            'graficaTipoSeg',
        ])
    }
}
</script>
